import { render, staticRenderFns } from "./TransApplyList.vue?vue&type=template&id=fccbfd64&"
import script from "./TransApplyList.vue?vue&type=script&lang=js&"
export * from "./TransApplyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports